const createModalApi = () => {
  const show = (id) => {
    const modal = document.getElementById(id);

    if (modal) {
      modal.showModal();

      // Récupération de l"instance Vue 3 du composant
      const vNode = modal.__vueParentComponent;
      if (vNode) {
        // Émission de l"événement before-open
        vNode.emit("before-open");
      }
    }
  };

  const hide = (id) => {
    const modal = document.getElementById(id);

    if (modal) {
      modal.classList.add("hide");

      const animationEndHandler = () => {
        modal.removeEventListener("animationend", animationEndHandler);
        modal.close();
        modal.classList.remove("hide");
      };

      modal.addEventListener("animationend", animationEndHandler);
    }
  };

  return {
    show,
    hide,
  };
};

export default {
  install: (app) => {
    const modal = createModalApi();
    app.config.globalProperties.$modal = modal;
    app.provide("modal", modal);
  },
};
